import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';
const SvgThreadOutlined = ({ size, title = 'ThreadOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <path stroke="currentColor" strokeLinecap="round" strokeWidth={1.5} d="M8.5 8.5H16m-7.5 3H14" />
        <path
            stroke="currentColor"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 5.244A1.25 1.25 0 015.24 4h14.02c.685 0 1.24.57 1.24 1.244v10.012c0 .687-.562 1.244-1.244 1.244H15.25v4l-5-4h-5c-.69 0-1.25-.57-1.25-1.244V5.244z"
            clipRule="evenodd"
        />
    </svg>
);
export default withIcon(SvgThreadOutlined);
